import { createSelector } from '@reduxjs/toolkit';
import { selectSuperSimplifierDetails } from '../../store/selectors';

export const selectPensionDetail = createSelector(selectSuperSimplifierDetails, (superSimplifierDetails) => superSimplifierDetails.pensionDetail.details);
export const selectPensionBankAccountDetails = createSelector(
  selectSuperSimplifierDetails,
  (superSimplifierDetails) => superSimplifierDetails.pensionDetail.bankDetails
);
